export default __webpack_public_path__ + "static/media/ICTS-Protiviti-negativo.ac8fd2dc.png";